import { RefObject, useEffect, useRef } from "react";

interface Args<T, W, D> {
  triggerCallback: ({ effectDependency }: { effectDependency: D }) => void;
  scrollTrigger: RefObject<T | null>;
  scrollWrapper: RefObject<W | null>;
  effectDependency: D;
}
export function useInfiniteScroll<T extends HTMLElement, W extends HTMLElement, D extends readonly unknown[]>({
  triggerCallback,
  scrollTrigger,
  scrollWrapper,
  effectDependency,
}: Args<T, W, D>) {
  const activeTimeOutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    const scrollTriggerEl = scrollTrigger.current;
    const scrollWrapperEl = scrollWrapper.current;
    if (!scrollTriggerEl || !scrollWrapperEl) return () => {};

    const modalScrollListener = () => {
      const scrollDiveFromTop = scrollTriggerEl.getBoundingClientRect().top;
      const wrapModalFromTop = scrollWrapperEl.getBoundingClientRect().height + scrollWrapperEl.scrollTop;

      // timeOut is just for check , if other request exist clean it and create new one
      if (activeTimeOutRef.current) {
        clearTimeout(activeTimeOutRef.current);
      }
      activeTimeOutRef.current = setTimeout(() => {
        // live check if scrollDive is valid for Scroll
        if (scrollDiveFromTop > 0 && scrollDiveFromTop <= wrapModalFromTop) {
          triggerCallback({ effectDependency });
        }
      }, 100);
    };

    // modal does not have enough height for Scroll
    if (scrollWrapperEl.clientHeight >= scrollWrapperEl.scrollHeight) {
      setTimeout(() => {
        triggerCallback({ effectDependency });
      }, 2000);
    }
    // modal have enough height for Scroll
    else {
      scrollWrapperEl.addEventListener("scroll", modalScrollListener);
    }

    return () => {
      scrollWrapperEl.removeEventListener("scroll", modalScrollListener);
      if (activeTimeOutRef.current) {
        clearTimeout(activeTimeOutRef.current);
      }
    };
  }, [effectDependency, scrollTrigger, scrollWrapper, triggerCallback]);
}
